






















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import MiniCalendar from '@ui/Calendar/MiniCalendar'
import SyncIndicator from '@components/SyncIndicator'

settings =
  name: 'AudienceListingShow'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'

  vue:
    components: {
      LoadingIndicator,
      AudienceListingDetail,
      MiniCalendar,
      SyncIndicator,
    }

    computed:
      actionsForAudienceListingDetail: ->
        addSuperNote: @addSuperNote

      optionsForCalendar: ->
        selectable: false
        dayCellClassNames: () => ['disabled']

      displaySyncIndicator: ->
        @audience_listing?.marked_for_sync || @audience_listing?.marked_as_syncing

    methods:
      addSuperNote: (newSuperNote) ->
        @triggerResource 'audience_listing', 'add_super_note', { note: newSuperNote }

export default VueOptions.vue settings
